export enum localStorageItem {
    REGION_LINES_VISIBILITY = 'regionLinesVisibility',
    MATERIAL_FLAGS_VISIBILITY = 'materialFlagsVisibility',
    MEASUREMENTS_VISIBILITY = 'measurementsVisibility',
    HIGHLIGHTS_VISIBILITY = 'highlightsVisibility',
    INITIAL_LOGIN_TIME = 'initialLoginTime',
    IS_TESTING_ENABLED = 'isTestingEnabled',
    NIGHTLY_STORAGE_KEY = 'nightlyFlagEnabled',
    NEW_IMUP_STORAGE_KEY = 'newIMUP',
}
